

import { Component, Mixins, Prop } from 'vue-property-decorator';
import Chart from 'chart.js';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
import { HorizontalBar } from 'vue-chartjs';

@Component({
  components: {
    ChartJsPluginDataLabels,
  },
})
export default class Bar2 extends Mixins(HorizontalBar) {
  @Prop(String) public height!: string;
  // グラフ用のデータ
  private chartData: Chart.ChartData = {
    labels: [],
    datasets: [
      {
        label: '未対応',
        // バーチャート内の件数の文字を編集
        datalabels: {
          labels: {
            value: {
              color: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
        type: 'horizontalBar',
        data: [4],
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderSkipped: 'chartArea',
        borderColor: 'rgb(255, 99, 132)',
        borderWidth: 1,
      },
      {
        label: '処理中',
        datalabels: {
          labels: {
            value: {
              color: 'rgba(0, 0, 0, 0.5)',
              align: 'center',
            },
          },
        },
        type: 'horizontalBar',
        data: [10],
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderSkipped: 'chartArea',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
      {
        label: '完了',
        datalabels: {
          labels: {
            value: {
              color: 'rgba(0, 0, 0, 0.5)',
              align: 'center',
            },
          },
        },
        type: 'horizontalBar',
        data: [6],
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderSkipped: 'chartArea',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  private chartOptions: Chart.ChartOptions = {
    // 凡例の位置
    legend: {
      position: 'bottom',
    },
    // レスポンシブ（true だとサイズ自動調整）
    responsive: true,
    // hover時に出現する吹き出しの表示切替
    tooltips: { enabled: false },
    // hover時のアニメーションの表示切替
    hover: { mode: undefined },
    scales: {
      // X軸
      xAxes: [
        {
          // グリッドラインの非表示
          gridLines: {
            drawBorder: false,
            display: false,
          },
          // グラフタイトルの非表示
          scaleLabel: {
            display: false,
            fontColor: '#999',
            labelString: 'Sales Quantity',
          },
          // @ts-ignore
          xbarThickness: 1, // 棒グラフの幅
          // 積み上げ描画true
          stacked: true,
          ticks: {
            display: false,
          },
        },
      ],
      // Y軸
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            display: false,
          },
          scaleLabel: {
            display: false,
          },
          stacked: true,
        },
      ],
    },
  };

  public mounted() {
    // グラフを描画
    this.renderChart(this.chartData, this.chartOptions);
  }
}
